import { Category } from "../category/category";
import { Week } from "../category/week";

export class updateCategories {
    categories: Array<Category>;
    weeks:Array<Week>
    constructor (categories,weeks = null) {
        this.categories = categories;
        if (weeks) {
            this.weeks = weeks.map(item => new Week(item));
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/broadcaster/update-categories.ts